'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CREATE_NEW_THREAD = exports.CREATE_NEW_THREAD = 'CREATE_NEW_THREAD';


//////////////////
// WEBPACK FOOTER
// ./js/threads/constants/actionTypes.js
// module id = 617
// module chunks = 2 3